var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWineGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Outline",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M338.9,438.049,280,432.694V299.676a16.043,16.043,0,0,1,12.862-15.69,113.478,113.478,0,0,0,89.573-130.553L359.884,22.641A8,8,0,0,0,352,16H160a8,8,0,0,0-7.884,6.641L129.565,153.433a113.477,113.477,0,0,0,89.574,130.553A16.044,16.044,0,0,1,232,299.676V432.694l-58.9,5.355A31.845,31.845,0,0,0,144,469.917V472a8,8,0,0,0,8,8H360a8,8,0,0,0,8-8v-2.083A31.845,31.845,0,0,0,338.9,438.049ZM166.738,32H345.262l17.931,104H346.956L334.308,62.641,318.54,65.359,330.72,136H148.807Zm55.538,236.3a97.48,97.48,0,0,1-76.943-112.146l.716-4.151h187.43l1.653,9.589a64.91,64.91,0,0,1-1.313,28.307l15.438,4.208A80.8,80.8,0,0,0,350.9,158.87L349.715,152h16.236l.716,4.151A97.481,97.481,0,0,1,289.725,268.3,32.085,32.085,0,0,0,264,299.676a8,8,0,0,1-16,0A32.085,32.085,0,0,0,222.276,268.3ZM161.114,464a15.922,15.922,0,0,1,13.438-10.018l66.173-6.015A8,8,0,0,0,248,440V322.3a23.944,23.944,0,0,0,16,0V440a8,8,0,0,0,7.275,7.967l66.173,6.015A15.922,15.922,0,0,1,350.886,464Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.792,218.807c1.541-2.248,2.982-4.588,4.283-6.954l-14.023-7.706c-1.048,1.908-2.21,3.8-3.454,5.61a66.317,66.317,0,0,1-7.093,8.67l11.478,11.146A82.388,82.388,0,0,0,337.792,218.807Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlass);
export default __webpack_public_path__ + "static/media/wine-glass.979d2d8b109ef610b058d3a82d520d45.svg";
export { ForwardRef as ReactComponent };